export default [
    '1031-Buyer',
    'Prior 1031',
    'Active',
];